<template>
    <div
        v-if="views && views.points.length > 1"
        :class="['visual-rotate', {'is-open': isOpen}]"
    >
        <button class="button-circle button-circle_theme_stroke visual-rotate__open-button" @click="isOpen = !isOpen">
            <iconRotate className="visual-rotate__svg-rotate"/>
            <iconClose className="visual-rotate__svg-close"/>
        </button>
        <div class="visual-rotate__container">
            <div v-if="views.planHouse" class="visual-rotate__house-plan">
                <img :src=views.planHouse alt="План комплекса">
            </div>
            <div class="visual-rotate__wrapper">
                <img class="visual-rotate__plan" :src=views.plan alt="Мини план">

                <template v-for="point in views.points">
                    <div
                        :class="['visual-rotate__point', {'is-active': point.id === rotate}]"
                        :style="{top: `${point.top}px`, left: `${point.left}px`, transform: `rotate(${point.deg}deg)`}"
                        :key="point.id"
                        @click="changeRotateByClick(point.id)"
                    >
                        <iconGradient className="visual-rotate__svg-gradient"/>
                        <div class="visual-rotate__circle"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "./Rotate.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import iconClose from '../Icons/icon-close.vue';
import iconGradient from '../Icons/icon-rotate-gradient.vue';
import iconRotate from '../Icons/icon-rotate.vue';

export default {
    data: () => {
        return {
            isOpen: false
        };
    },

    components: {
        iconGradient,
        iconRotate,
        iconClose
    },

    computed: {
        ...mapGetters({
            views : 'GET_VIEWS',
            rotate: 'GET_ROTATE'
        })
    },

    methods: {
        ...mapActions(['changeRotate']),

        changeRotateByClick(id) {
            this.changeRotate(id);
            this.isOpen = false;
        }
    }
};
</script>

